import type { ISOCountryExtra } from "../types.js";

export const countriesExtra: ISOCountryExtra = {
	AD: {
		tld: ".ad",
		dial: "376",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "1/19/Flag_of_Andorra",
		emoji: "🇦",
		emojiU: "U+1F1E6 U+1F1E9",
		coordinates: [42.5462, 1.6016],
	},
	AE: {
		tld: ".ae",
		dial: "971",
		currency: {
			code: "AED",
			symbol: "AED",
			original: "د.إ.�",
			name: "United Arab Emirates Dirham",
		},
		flag: "c/cb/Flag_of_the_United_Arab_Emirates",
		emoji: "🇦",
		emojiU: "U+1F1E6 U+1F1EA",
		coordinates: [23.4241, 53.8478],
	},
	AF: {
		tld: ".af",
		dial: "93",
		currency: {
			code: "AFN",
			symbol: "Af",
			original: "؋",
			name: "Afghan Afghani",
		},
		flag: "5/5c/Flag_of_the_Taliban",
		emoji: "🇦",
		emojiU: "U+1F1E6 U+1F1EB",
		coordinates: [33.9391, 67.71],
	},
	AG: {
		tld: ".ag",
		dial: "1-268",
		currency: {
			code: "XCD",
			name: "East Caribbean Dollar",
		},
		flag: "8/89/Flag_of_Antigua_and_Barbuda",
		emoji: "🇦",
		emojiU: "U+1F1E6 U+1F1EC",
		coordinates: [17.0608, -61.7964],
	},
	AI: {
		tld: ".ai",
		dial: "1-264",
		currency: {
			code: "XCD",
			name: "East Caribbean Dollar",
		},
		flag: "b/b4/Flag_of_Anguilla",
		emoji: "🇦",
		emojiU: "U+1F1E6 U+1F1EE",
		coordinates: [18.2206, -63.0686],
	},
	AL: {
		tld: ".al",
		dial: "355",
		currency: {
			code: "ALL",
			symbol: "ALL",
			original: "Lek",
			name: "Albanian Lek",
		},
		flag: "3/36/Flag_of_Albania",
		emoji: "🇦",
		emojiU: "U+1F1E6 U+1F1F1",
		coordinates: [41.1533, 20.1683],
	},
	AM: {
		tld: ".am",
		dial: "374",
		currency: {
			code: "AMD",
			symbol: "AMD",
			original: "դր.",
			name: "Armenian Dram",
		},
		flag: "2/2f/Flag_of_Armenia",
		emoji: "🇦",
		emojiU: "U+1F1E6 U+1F1F2",
		coordinates: [40.0691, 45.0382],
	},
	AO: {
		tld: ".ao",
		dial: "244",
		currency: {
			code: "AOA",
			name: "Kwanza",
		},
		flag: "9/9d/Flag_of_Angola",
		emoji: "🇦",
		emojiU: "U+1F1E6 U+1F1F4",
		coordinates: [-11.2027, 17.8739],
	},
	AQ: {
		tld: ".aq",
		dial: "672",
		currency: {
			name: "No universal currency",
		},
		flag: "f/f8/True_South_Antarctic_Flag",
		emoji: "🇦",
		emojiU: "U+1F1E6 U+1F1F6",
		coordinates: [-75.251, -0.0714],
	},
	AR: {
		tld: ".ar",
		dial: "54",
		currency: {
			code: "ARS",
			symbol: "AR$",
			original: "$",
			name: "Argentine Peso",
		},
		flag: "1/1a/Flag_of_Argentina",
		emoji: "🇦",
		emojiU: "U+1F1E6 U+1F1F7",
		coordinates: [-38.4161, -63.6167],
	},
	AS: {
		tld: ".as",
		dial: "1-684",
		currency: {
			code: "USD",
			symbol: "$",
			original: "$",
			name: "US Dollar",
		},
		flag: "8/87/Flag_of_American_Samoa",
		emoji: "🇦",
		emojiU: "U+1F1E6 U+1F1F8",
		coordinates: [-14.271, -170.1322],
	},
	AT: {
		tld: ".at",
		dial: "43",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "4/41/Flag_of_Austria",
		emoji: "🇦",
		emojiU: "U+1F1E6 U+1F1F9",
		coordinates: [47.5162, 14.5501],
	},
	AU: {
		tld: ".au",
		dial: "61",
		currency: {
			code: "AUD",
			symbol: "AU$",
			original: "$",
			name: "Australian Dollar",
		},
		flag: "8/88/Flag_of_Australia_(converted)",
		emoji: "🇦",
		emojiU: "U+1F1E6 U+1F1FA",
		coordinates: [-25.2744, 133.7751],
	},
	AW: {
		tld: ".aw",
		dial: "297",
		currency: {
			code: "AWG",
			name: "Aruban Florin",
		},
		flag: "f/f6/Flag_of_Aruba",
		emoji: "🇦",
		emojiU: "U+1F1E6 U+1F1FC",
		coordinates: [12.5211, -69.9683],
	},
	AX: {
		tld: ".ax",
		dial: "358",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "5/52/Flag_of_%C3%85land",
		emoji: "🇦",
		emojiU: "U+1F1E6 U+1F1FD",
		coordinates: [60.1785, 19.9156],
	},
	AZ: {
		tld: ".az",
		dial: "994",
		currency: {
			code: "AZN",
			symbol: "man.",
			original: "ман.",
			name: "Azerbaijani Manat",
		},
		flag: "d/dd/Flag_of_Azerbaijan",
		emoji: "🇦",
		emojiU: "U+1F1E6 U+1F1FF",
		coordinates: [40.1431, 47.5769],
	},
	BA: {
		tld: ".ba",
		dial: "387",
		currency: {
			code: "BAM",
			symbol: "KM",
			original: "KM",
			name: "Bosnia-Herzegovina Convertible Mark",
		},
		flag: "b/bf/Flag_of_Bosnia_and_Herzegovina",
		emoji: "🇧",
		emojiU: "U+1F1E7 U+1F1E6",
		coordinates: [43.9159, 17.6791],
	},
	BB: {
		tld: ".bb",
		dial: "1-246",
		currency: {
			code: "BBD",
			name: "Barbados Dollar",
		},
		flag: "e/ef/Flag_of_Barbados",
		emoji: "🇧",
		emojiU: "U+1F1E7 U+1F1E7",
		coordinates: [13.1939, -59.5432],
	},
	BD: {
		tld: ".bd",
		dial: "880",
		currency: {
			code: "BDT",
			symbol: "Tk",
			original: "৳",
			name: "Bangladeshi Taka",
		},
		flag: "f/f9/Flag_of_Bangladesh",
		emoji: "🇧",
		emojiU: "U+1F1E7 U+1F1E9",
		coordinates: [23.685, 90.3563],
	},
	BE: {
		tld: ".be",
		dial: "32",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "6/65/Flag_of_Belgium",
		emoji: "🇧",
		emojiU: "U+1F1E7 U+1F1EA",
		coordinates: [50.5039, 4.4699],
	},
	BF: {
		tld: ".bf",
		dial: "226",
		currency: {
			code: "XOF",
			symbol: "CFA",
			original: "CFA",
			name: "CFA Franc BCEAO",
		},
		flag: "3/31/Flag_of_Burkina_Faso",
		emoji: "🇧",
		emojiU: "U+1F1E7 U+1F1EB",
		coordinates: [12.2383, -1.5616],
	},
	BG: {
		tld: ".bg",
		dial: "359",
		currency: {
			code: "BGN",
			symbol: "BGN",
			original: "лв.",
			name: "Bulgarian Lev",
		},
		flag: "9/9a/Flag_of_Bulgaria",
		emoji: "🇧",
		emojiU: "U+1F1E7 U+1F1EC",
		coordinates: [42.7339, 25.4858],
	},
	BH: {
		tld: ".bh",
		dial: "973",
		currency: {
			code: "BHD",
			symbol: "BD",
			original: "د.ب.�",
			name: "Bahraini Dinar",
		},
		flag: "2/2c/Flag_of_Bahrain",
		emoji: "🇧",
		emojiU: "U+1F1E7 U+1F1ED",
		coordinates: [25.9304, 50.6378],
	},
	BI: {
		tld: ".bi",
		dial: "257",
		currency: {
			code: "BIF",
			symbol: "FBu",
			original: "FBu",
			name: "Burundian Franc",
		},
		flag: "5/50/Flag_of_Burundi",
		emoji: "🇧",
		emojiU: "U+1F1E7 U+1F1EE",
		coordinates: [-3.3731, 29.9189],
	},
	BJ: {
		tld: ".bj",
		dial: "229",
		currency: {
			code: "XOF",
			symbol: "CFA",
			original: "CFA",
			name: "CFA Franc BCEAO",
		},
		flag: "0/0a/Flag_of_Benin",
		emoji: "🇧",
		emojiU: "U+1F1E7 U+1F1EF",
		coordinates: [9.3077, 2.3158],
	},
	BL: {
		tld: ".gp",
		dial: "590",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "0/03/Saint-Barthelémy_Icône",
		emoji: "🇧",
		emojiU: "U+1F1E7 U+1F1F1",
		coordinates: [17.9, 62.8333],
	},
	BM: {
		tld: ".bm",
		dial: "1-441",
		currency: {
			code: "BMD",
			name: "Bermudian Dollar",
		},
		flag: "b/bf/Flag_of_Bermuda",
		emoji: "🇧",
		emojiU: "U+1F1E7 U+1F1F2",
		coordinates: [32.3214, -64.7574],
	},
	BN: {
		tld: ".bn",
		dial: "673",
		currency: {
			code: "BND",
			symbol: "BN$",
			original: "$",
			name: "Brunei Dollar",
		},
		flag: "9/9c/Flag_of_Brunei",
		emoji: "🇧",
		emojiU: "U+1F1E7 U+1F1F3",
		coordinates: [4.5353, 114.7277],
	},
	BO: {
		tld: ".bo",
		dial: "591",
		currency: {
			code: "BOB",
			symbol: "Bs",
			original: "Bs",
			name: "Bolivian Boliviano",
		},
		flag: "5/5b/Bolivia_Flag",
		emoji: "🇧",
		emojiU: "U+1F1E7 U+1F1F4",
		coordinates: [-16.2902, -63.5887],
	},
	BQ: {
		tld: ".bq",
		dial: "599",
		currency: {
			code: "USD",
			symbol: "$",
			original: "$",
			name: "US Dollar",
		},
		flag: "2/20/Flag_of_the_Netherlands",
		emoji: "🇧",
		emojiU: "U+1F1E7 U+1F1F6",
		coordinates: [12.1784, 68.2385],
	},
	BR: {
		tld: ".br",
		dial: "55",
		currency: {
			code: "BRL",
			symbol: "R$",
			original: "R$",
			name: "Brazilian Real",
		},
		flag: "0/05/Flag_of_Brazil",
		emoji: "🇧",
		emojiU: "U+1F1E7 U+1F1F7",
		coordinates: [-14.235, -51.9253],
	},
	BS: {
		tld: ".bs",
		dial: "1-242",
		currency: {
			code: "BSD",
			name: "Bahamian Dollar",
		},
		flag: "9/93/Flag_of_the_Bahamas",
		emoji: "🇧",
		emojiU: "U+1F1E7 U+1F1F8",
		coordinates: [25.0343, -77.3963],
	},
	BT: {
		tld: ".bt",
		dial: "975",
		currency: {
			code: "INR,BTN",
			name: "Indian Rupee,Ngultrum",
		},
		flag: "9/91/Flag_of_Bhutan",
		emoji: "🇧",
		emojiU: "U+1F1E7 U+1F1F9",
		coordinates: [27.5142, 90.4336],
	},
	BV: {
		tld: ".bv",
		dial: "47",
		currency: {
			code: "NOK",
			symbol: "Nkr",
			original: "kr",
			name: "Norwegian Krone",
		},
		flag: "d/d9/Flag_of_Norway",
		emoji: "🇧",
		emojiU: "U+1F1E7 U+1F1FB",
		coordinates: [-54.4232, 3.4132],
	},
	BW: {
		tld: ".bw",
		dial: "267",
		currency: {
			code: "BWP",
			symbol: "BWP",
			original: "P",
			name: "Botswanan Pula",
		},
		flag: "f/fa/Flag_of_Botswana",
		emoji: "🇧",
		emojiU: "U+1F1E7 U+1F1FC",
		coordinates: [-22.3285, 24.6849],
	},
	BY: {
		tld: ".by",
		dial: "375",
		currency: {
			code: "BYN",
			symbol: "Br",
			original: "руб.",
			name: "Belarusian Ruble",
		},
		flag: "8/85/Flag_of_Belarus",
		emoji: "🇧",
		emojiU: "U+1F1E7 U+1F1FE",
		coordinates: [53.7098, 27.9534],
	},
	BZ: {
		tld: ".bz",
		dial: "501",
		currency: {
			code: "BZD",
			symbol: "BZ$",
			original: "$",
			name: "Belize Dollar",
		},
		flag: "e/e7/Flag_of_Belize",
		emoji: "🇧",
		emojiU: "U+1F1E7 U+1F1FF",
		coordinates: [17.1899, -88.4976],
	},
	CA: {
		tld: ".ca",
		dial: "1",
		currency: {
			code: "CAD",
			symbol: "CA$",
			original: "$",
			name: "Canadian Dollar",
		},
		flag: "d/d9/Flag_of_Canada_(Pantone)",
		emoji: "🇨",
		emojiU: "U+1F1E8 U+1F1E6",
		coordinates: [56.1304, -106.3468],
	},
	CC: {
		tld: ".cc",
		dial: "61",
		currency: {
			code: "AUD",
			symbol: "AU$",
			original: "$",
			name: "Australian Dollar",
		},
		flag: "7/74/Flag_of_the_Cocos_(Keeling)_Islands",
		emoji: "🇨",
		emojiU: "U+1F1E8 U+1F1E8",
		coordinates: [-12.1642, 96.871],
	},
	CD: {
		tld: ".cd",
		dial: "243",
		currency: {
			code: "CDF",
			symbol: "CDF",
			original: "FrCD",
			name: "Congolese Franc",
		},
		flag: "1/11/Flag_of_the_Democratic_Republic_of_the_Congo_(3-2)",
		emoji: "🇨",
		emojiU: "U+1F1E8 U+1F1E9",
		coordinates: [-4.0383, 21.7587],
	},
	CF: {
		tld: ".cf",
		dial: "236",
		currency: {
			code: "XAF",
			symbol: "FCFA",
			original: "FCFA",
			name: "CFA Franc BEAC",
		},
		flag: "6/6f/Flag_of_the_Central_African_Republic",
		emoji: "🇨",
		emojiU: "U+1F1E8 U+1F1EB",
		coordinates: [6.6111, 20.9394],
	},
	CG: {
		tld: ".cg",
		dial: "242",
		currency: {
			code: "XAF",
			symbol: "FCFA",
			original: "FCFA",
			name: "CFA Franc BEAC",
		},
		flag: "9/92/Flag_of_the_Republic_of_the_Congo",
		emoji: "🇨",
		emojiU: "U+1F1E8 U+1F1EC",
		coordinates: [-0.228, 15.8277],
	},
	CH: {
		tld: ".ch",
		dial: "41",
		currency: {
			code: "CHF",
			symbol: "CHF",
			original: "CHF",
			name: "Swiss Franc",
		},
		flag: "f/f3/Flag_of_Switzerland",
		emoji: "🇨",
		emojiU: "U+1F1E8 U+1F1ED",
		coordinates: [46.8182, 8.2275],
	},
	CI: {
		tld: ".ci",
		dial: "225",
		currency: {
			code: "XOF",
			symbol: "CFA",
			original: "CFA",
			name: "CFA Franc BCEAO",
		},
		flag: "f/fe/Flag_of_Côte_d%27Ivoire",
		emoji: "🇨",
		emojiU: "U+1F1E8 U+1F1EE",
		coordinates: [7.54, -5.5471],
	},
	CK: {
		tld: ".ck",
		dial: "682",
		currency: {
			code: "NZD",
			symbol: "NZ$",
			original: "$",
			name: "New Zealand Dollar",
		},
		flag: "3/35/Flag_of_the_Cook_Islands",
		emoji: "🇨",
		emojiU: "U+1F1E8 U+1F1F0",
		coordinates: [-21.2367, -159.7777],
	},
	CL: {
		tld: ".cl",
		dial: "56",
		currency: {
			code: "CLP",
			symbol: "CL$",
			original: "$",
			name: "Chilean Peso",
		},
		flag: "7/78/Flag_of_Chile",
		emoji: "🇨",
		emojiU: "U+1F1E8 U+1F1F1",
		coordinates: [-35.6751, -71.543],
	},
	CM: {
		tld: ".cm",
		dial: "237",
		currency: {
			code: "XAF",
			symbol: "FCFA",
			original: "FCFA",
			name: "CFA Franc BEAC",
		},
		flag: "4/4f/Flag_of_Cameroon",
		emoji: "🇨",
		emojiU: "U+1F1E8 U+1F1F2",
		coordinates: [7.3697, 12.3547],
	},
	CN: {
		tld: ".cn",
		dial: "86",
		currency: {
			code: "CNY",
			symbol: "CN¥",
			original: "CN¥",
			name: "Chinese Yuan",
		},
		flag: "f/fa/Flag_of_the_People%27s_Republic_of_China",
		emoji: "🇨",
		emojiU: "U+1F1E8 U+1F1F3",
		coordinates: [35.8617, 104.1954],
	},
	CO: {
		tld: ".co",
		dial: "57",
		currency: {
			code: "COP",
			symbol: "CO$",
			original: "$",
			name: "Colombian Peso",
		},
		flag: "2/21/Flag_of_Colombia",
		emoji: "🇨",
		emojiU: "U+1F1E8 U+1F1F4",
		coordinates: [4.5709, -74.2973],
	},
	CR: {
		tld: ".cr",
		dial: "506",
		currency: {
			code: "CRC",
			symbol: "₡",
			original: "₡",
			name: "Costa Rican Colón",
		},
		flag: "b/bc/Flag_of_Costa_Rica_(state)",
		emoji: "🇨",
		emojiU: "U+1F1E8 U+1F1F7",
		coordinates: [9.7489, -83.7534],
	},
	CU: {
		tld: ".cu",
		dial: "53",
		currency: {
			code: "CUP,CUC",
			name: "Cuban Peso,Peso Convertible",
		},
		flag: "b/bd/Flag_of_Cuba",
		emoji: "🇨",
		emojiU: "U+1F1E8 U+1F1FA",
		coordinates: [21.5218, -77.7812],
	},
	CV: {
		tld: ".cv",
		dial: "238",
		currency: {
			code: "CVE",
			symbol: "CV$",
			original: "CV$",
			name: "Cape Verdean Escudo",
		},
		flag: "3/38/Flag_of_Cape_Verde",
		emoji: "🇨",
		emojiU: "U+1F1E8 U+1F1FB",
		coordinates: [16.0021, -24.0132],
	},
	CW: {
		tld: ".cw",
		dial: "599",
		currency: {
			code: "ANG",
			name: "Netherlands Antillean Guilder",
		},
		flag: "b/b1/Flag_of_Curaçao",
		emoji: "🇨",
		emojiU: "U+1F1E8 U+1F1FC",
		coordinates: [12.1696, 68.99],
	},
	CX: {
		tld: ".cx",
		dial: "61",
		currency: {
			code: "AUD",
			symbol: "AU$",
			original: "$",
			name: "Australian Dollar",
		},
		flag: "6/67/Flag_of_Christmas_Island",
		emoji: "🇨",
		emojiU: "U+1F1E8 U+1F1FD",
		coordinates: [-10.4475, 105.6904],
	},
	CY: {
		tld: ".cy",
		dial: "357",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "d/d4/Flag_of_Cyprus",
		emoji: "🇨",
		emojiU: "U+1F1E8 U+1F1FE",
		coordinates: [35.1264, 33.4299],
	},
	CZ: {
		tld: ".cz",
		dial: "420",
		currency: {
			code: "CZK",
			symbol: "Kč",
			original: "Kč",
			name: "Czech Republic Koruna",
		},
		flag: "c/cb/Flag_of_the_Czech_Republic",
		emoji: "🇨",
		emojiU: "U+1F1E8 U+1F1FF",
		coordinates: [49.8175, 15.473],
	},
	DE: {
		tld: ".de",
		dial: "49",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "b/ba/Flag_of_Germany",
		emoji: "🇩",
		emojiU: "U+1F1E9 U+1F1EA",
		coordinates: [51.1657, 10.4515],
	},
	DJ: {
		tld: ".dj",
		dial: "253",
		currency: {
			code: "DJF",
			symbol: "Fdj",
			original: "Fdj",
			name: "Djiboutian Franc",
		},
		flag: "3/34/Flag_of_Djibouti",
		emoji: "🇩",
		emojiU: "U+1F1E9 U+1F1EF",
		coordinates: [11.8251, 42.5903],
	},
	DK: {
		tld: ".dk",
		dial: "45",
		currency: {
			code: "DKK",
			symbol: "Dkr",
			original: "kr",
			name: "Danish Krone",
		},
		flag: "9/9c/Flag_of_Denmark",
		emoji: "🇩",
		emojiU: "U+1F1E9 U+1F1F0",
		coordinates: [56.2639, 9.5018],
	},
	DM: {
		tld: ".dm",
		dial: "1-767",
		currency: {
			code: "XCD",
			name: "East Caribbean Dollar",
		},
		flag: "c/c4/Flag_of_Dominica",
		emoji: "🇩",
		emojiU: "U+1F1E9 U+1F1F2",
		coordinates: [15.415, -61.371],
	},
	DO: {
		tld: ".do",
		dial: "1-809,1-829,1-849",
		currency: {
			code: "DOP",
			symbol: "RD$",
			original: "RD$",
			name: "Dominican Peso",
		},
		flag: "9/9f/Flag_of_the_Dominican_Republic",
		emoji: "🇩",
		emojiU: "U+1F1E9 U+1F1F4",
		coordinates: [18.7357, -70.1627],
	},
	DZ: {
		tld: ".dz",
		dial: "213",
		currency: {
			code: "DZD",
			symbol: "DA",
			original: "د.ج.�",
			name: "Algerian Dinar",
		},
		flag: "7/77/Flag_of_Algeria",
		emoji: "🇩",
		emojiU: "U+1F1E9 U+1F1FF",
		coordinates: [28.0339, 1.6596],
	},
	EC: {
		tld: ".ec",
		dial: "593",
		currency: {
			code: "USD",
			symbol: "$",
			original: "$",
			name: "US Dollar",
		},
		flag: "e/e8/Flag_of_Ecuador",
		emoji: "🇪",
		emojiU: "U+1F1EA U+1F1E8",
		coordinates: [-1.8312, -78.1834],
	},
	EE: {
		tld: ".ee",
		dial: "372",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "8/8f/Flag_of_Estonia",
		emoji: "🇪",
		emojiU: "U+1F1EA U+1F1EA",
		coordinates: [58.5953, 25.0136],
	},
	EG: {
		tld: ".eg",
		dial: "20",
		currency: {
			code: "EGP",
			symbol: "EGP",
			original: "ج.م.�",
			name: "Egyptian Pound",
		},
		flag: "f/fe/Flag_of_Egypt",
		emoji: "🇪",
		emojiU: "U+1F1EA U+1F1EC",
		coordinates: [26.8206, 30.8025],
	},
	EH: {
		tld: ".eh",
		dial: "212",
		currency: {
			code: "MAD",
			symbol: "MAD",
			original: "د.م.�",
			name: "Moroccan Dirham",
		},
		flag: "2/26/Flag_of_the_Sahrawi_Arab_Democratic_Republic",
		emoji: "🇪",
		emojiU: "U+1F1EA U+1F1ED",
		coordinates: [24.2155, -12.8858],
	},
	ER: {
		tld: ".er",
		dial: "291",
		currency: {
			code: "ERN",
			symbol: "Nfk",
			original: "Nfk",
			name: "Eritrean Nakfa",
		},
		flag: "2/29/Flag_of_Eritrea",
		emoji: "🇪",
		emojiU: "U+1F1EA U+1F1F7",
		coordinates: [15.1794, 39.7823],
	},
	ES: {
		tld: ".es",
		dial: "34",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "9/9a/Flag_of_Spain",
		emoji: "🇪",
		emojiU: "U+1F1EA U+1F1F8",
		coordinates: [40.4637, -3.7492],
	},
	ET: {
		tld: ".et",
		dial: "251",
		currency: {
			code: "ETB",
			symbol: "Br",
			original: "Br",
			name: "Ethiopian Birr",
		},
		flag: "7/71/Flag_of_Ethiopia",
		emoji: "🇪",
		emojiU: "U+1F1EA U+1F1F9",
		coordinates: [9.145, 40.4897],
	},
	FI: {
		tld: ".fi",
		dial: "358",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "b/bc/Flag_of_Finland",
		emoji: "🇫",
		emojiU: "U+1F1EB U+1F1EE",
		coordinates: [61.9241, 25.7482],
	},
	FJ: {
		tld: ".fj",
		dial: "679",
		currency: {
			code: "FJD",
			name: "Fiji Dollar",
		},
		flag: "b/ba/Flag_of_Fiji",
		emoji: "🇫",
		emojiU: "U+1F1EB U+1F1EF",
		coordinates: [-16.5782, 179.4144],
	},
	FK: {
		tld: ".fk",
		dial: "500",
		flag: "8/83/Flag_of_the_Falkland_Islands",
		emoji: "🇫",
		emojiU: "U+1F1EB U+1F1F0",
		coordinates: [-51.7963, -59.5236],
	},
	FM: {
		tld: ".fm",
		dial: "691",
		currency: {
			code: "USD",
			symbol: "$",
			original: "$",
			name: "US Dollar",
		},
		flag: "e/e4/Flag_of_the_Federated_States_of_Micronesia",
		emoji: "🇫",
		emojiU: "U+1F1EB U+1F1F2",
		coordinates: [7.4256, 150.5508],
	},
	FO: {
		tld: ".fo",
		dial: "298",
		currency: {
			code: "DKK",
			symbol: "Dkr",
			original: "kr",
			name: "Danish Krone",
		},
		flag: "3/3c/Flag_of_the_Faroe_Islands",
		emoji: "🇫",
		emojiU: "U+1F1EB U+1F1F4",
		coordinates: [61.8926, -6.9118],
	},
	FR: {
		tld: ".fr",
		dial: "33",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "c/c3/Flag_of_France",
		emoji: "🇫",
		emojiU: "U+1F1EB U+1F1F7",
		coordinates: [46.2276, 2.2137],
	},
	GA: {
		tld: ".ga",
		dial: "241",
		currency: {
			code: "XAF",
			symbol: "FCFA",
			original: "FCFA",
			name: "CFA Franc BEAC",
		},
		flag: "0/04/Flag_of_Gabon",
		emoji: "🇬",
		emojiU: "U+1F1EC U+1F1E6",
		coordinates: [-0.8037, 11.6094],
	},
	GB: {
		tld: ".uk",
		dial: "44",
		currency: {
			code: "GBP",
			symbol: "£",
			original: "£",
			name: "British Pound Sterling",
		},
		flag: "8/83/Flag_of_the_United_Kingdom_%283-5%29",
		emoji: "🇬",
		emojiU: "U+1F1EC U+1F1E7",
		coordinates: [55.3781, -3.436],
	},
	GD: {
		tld: ".gd",
		dial: "1-473",
		currency: {
			code: "XCD",
			name: "East Caribbean Dollar",
		},
		flag: "b/bc/Flag_of_Grenada",
		emoji: "🇬",
		emojiU: "U+1F1EC U+1F1E9",
		coordinates: [12.2628, -61.6042],
	},
	GE: {
		tld: ".ge",
		dial: "995",
		currency: {
			code: "GEL",
			symbol: "GEL",
			original: "GEL",
			name: "Georgian Lari",
		},
		flag: "0/0f/Flag_of_Georgia",
		emoji: "🇬",
		emojiU: "U+1F1EC U+1F1EA",
		coordinates: [42.3154, 43.3569],
	},
	GF: {
		tld: ".gf",
		dial: "594",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "e/ed/Flag_of_France_%28Pantone%29",
		emoji: "🇬",
		emojiU: "U+1F1EC U+1F1EB",
		coordinates: [3.9339, -53.1258],
	},
	GG: {
		tld: ".gg",
		dial: "44",
		currency: {
			code: "GBP",
			symbol: "£",
			original: "£",
			name: "British Pound Sterling",
		},
		flag: "f/fa/Flag_of_Guernsey",
		emoji: "🇬",
		emojiU: "U+1F1EC U+1F1EC",
		coordinates: [49.4657, -2.5853],
	},
	GH: {
		tld: ".gh",
		dial: "233",
		currency: {
			code: "GHS",
			symbol: "GH₵",
			original: "GH₵",
			name: "Ghanaian Cedi",
		},
		flag: "1/19/Flag_of_Ghana",
		emoji: "🇬",
		emojiU: "U+1F1EC U+1F1ED",
		coordinates: [7.9465, -1.0232],
	},
	GI: {
		tld: ".gi",
		dial: "350",
		currency: {
			code: "GIP",
			name: "Gibraltar Pound",
		},
		flag: "0/02/Flag_of_Gibraltar",
		emoji: "🇬",
		emojiU: "U+1F1EC U+1F1EE",
		coordinates: [36.1377, -5.3454],
	},
	GL: {
		tld: ".gl",
		dial: "299",
		currency: {
			code: "DKK",
			symbol: "Dkr",
			original: "kr",
			name: "Danish Krone",
		},
		flag: "0/09/Flag_of_Greenland",
		emoji: "🇬",
		emojiU: "U+1F1EC U+1F1F1",
		coordinates: [71.7069, -42.6043],
	},
	GM: {
		tld: ".gm",
		dial: "220",
		currency: {
			code: "GMD",
			name: "Dalasi",
		},
		flag: "7/77/Flag_of_The_Gambia",
		emoji: "🇬",
		emojiU: "U+1F1EC U+1F1F2",
		coordinates: [13.4432, -15.3101],
	},
	GN: {
		tld: ".gn",
		dial: "224",
		currency: {
			code: "GNF",
			symbol: "FG",
			original: "FG",
			name: "Guinean Franc",
		},
		flag: "e/ed/Flag_of_Guinea",
		emoji: "🇬",
		emojiU: "U+1F1EC U+1F1F3",
		coordinates: [9.9456, -9.6966],
	},
	GP: {
		tld: ".gp",
		dial: "590",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "9/9f/Flag_of_France_%287x10%29",
		emoji: "🇬",
		emojiU: "U+1F1EC U+1F1F5",
		coordinates: [16.996, -62.0676],
	},
	GQ: {
		tld: ".gq",
		dial: "240",
		currency: {
			code: "XAF",
			symbol: "FCFA",
			original: "FCFA",
			name: "CFA Franc BEAC",
		},
		flag: "3/31/Flag_of_Equatorial_Guinea",
		emoji: "🇬",
		emojiU: "U+1F1EC U+1F1F6",
		coordinates: [1.6508, 10.2679],
	},
	GR: {
		tld: ".gr",
		dial: "30",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "5/5c/Flag_of_Greece",
		emoji: "🇬",
		emojiU: "U+1F1EC U+1F1F7",
		coordinates: [39.0742, 21.8243],
	},
	GS: {
		tld: ".gs",
		dial: "500",
		currency: {
			name: "No universal currency",
		},
		flag: "e/ed/Flag_of_South_Georgia_and_the_South_Sandwich_Islands",
		emoji: "🇬",
		emojiU: "U+1F1EC U+1F1F8",
		coordinates: [-54.4296, -36.5879],
	},
	GT: {
		tld: ".gt",
		dial: "502",
		currency: {
			code: "GTQ",
			symbol: "GTQ",
			original: "Q",
			name: "Guatemalan Quetzal",
		},
		flag: "e/ec/Flag_of_Guatemala",
		emoji: "🇬",
		emojiU: "U+1F1EC U+1F1F9",
		coordinates: [15.7835, -90.2308],
	},
	GU: {
		tld: ".gu",
		dial: "1-671",
		currency: {
			code: "USD",
			symbol: "$",
			original: "$",
			name: "US Dollar",
		},
		flag: "0/07/Flag_of_Guam",
		emoji: "🇬",
		emojiU: "U+1F1EC U+1F1FA",
		coordinates: [13.4443, 144.7937],
	},
	GW: {
		tld: ".gw",
		dial: "245",
		currency: {
			code: "XOF",
			symbol: "CFA",
			original: "CFA",
			name: "CFA Franc BCEAO",
		},
		flag: "0/01/Flag_of_Guinea-Bissau",
		emoji: "🇬",
		emojiU: "U+1F1EC U+1F1FC",
		coordinates: [11.8037, -15.1804],
	},
	GY: {
		tld: ".gy",
		dial: "592",
		currency: {
			code: "GYD",
			name: "Guyana Dollar",
		},
		flag: "9/99/Flag_of_Guyana",
		emoji: "🇬",
		emojiU: "U+1F1EC U+1F1FE",
		coordinates: [4.8604, -58.9302],
	},
	HK: {
		tld: ".hk",
		dial: "852",
		currency: {
			code: "HKD",
			symbol: "HK$",
			original: "$",
			name: "Hong Kong Dollar",
		},
		flag: "5/5b/Flag_of_Hong_Kong",
		emoji: "🇭",
		emojiU: "U+1F1ED U+1F1F0",
		coordinates: [22.3964, 114.1095],
	},
	HM: {
		tld: ".hm",
		dial: "672",
		currency: {
			code: "AUD",
			symbol: "AU$",
			original: "$",
			name: "Australian Dollar",
		},
		flag: "8/88/Flag_of_Australia_(converted)",
		emoji: "🇭",
		emojiU: "U+1F1ED U+1F1F2",
		coordinates: [-53.0818, 73.5042],
	},
	HN: {
		tld: ".hn",
		dial: "504",
		currency: {
			code: "HNL",
			symbol: "HNL",
			original: "L",
			name: "Honduran Lempira",
		},
		flag: "8/82/Flag_of_Honduras",
		emoji: "🇭",
		emojiU: "U+1F1ED U+1F1F3",
		coordinates: [15.2, -86.2419],
	},
	HR: {
		tld: ".hr",
		dial: "385",
		currency: {
			code: "HRK",
			symbol: "kn",
			original: "kn",
			name: "Croatian Kuna",
		},
		flag: "1/1b/Flag_of_Croatia",
		emoji: "🇭",
		emojiU: "U+1F1ED U+1F1F7",
		coordinates: [45.1, 15.2],
	},
	HT: {
		tld: ".ht",
		dial: "509",
		currency: {
			code: "HTG,USD",
			name: "Gourde,US Dollar",
		},
		flag: "5/56/Flag_of_Haiti",
		emoji: "🇭",
		emojiU: "U+1F1ED U+1F1F9",
		coordinates: [18.9712, -72.2852],
	},
	HU: {
		tld: ".hu",
		dial: "36",
		currency: {
			code: "HUF",
			symbol: "Ft",
			original: "Ft",
			name: "Hungarian Forint",
		},
		flag: "c/c1/Flag_of_Hungary",
		emoji: "🇭",
		emojiU: "U+1F1ED U+1F1FA",
		coordinates: [47.1625, 19.5033],
	},
	ID: {
		tld: ".id",
		dial: "62",
		currency: {
			code: "IDR",
			symbol: "Rp",
			original: "Rp",
			name: "Indonesian Rupiah",
		},
		flag: "9/9f/Flag_of_Indonesia",
		emoji: "🇮",
		emojiU: "U+1F1EE U+1F1E9",
		coordinates: [-0.7893, 113.9213],
	},
	IE: {
		tld: ".ie",
		dial: "353",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "c/c0/Republic_of_Ireland_Flag",
		emoji: "🇮",
		emojiU: "U+1F1EE U+1F1EA",
		coordinates: [53.4129, -8.2439],
	},
	IL: {
		tld: ".il",
		dial: "972",
		currency: {
			code: "ILS",
			symbol: "₪",
			original: "₪",
			name: "Israeli New Sheqel",
		},
		flag: "d/d4/Flag_of_Israel",
		emoji: "🇮",
		emojiU: "U+1F1EE U+1F1F1",
		coordinates: [31.0461, 34.8516],
	},
	IM: {
		tld: ".im",
		dial: "44",
		currency: {
			code: "GBP",
			symbol: "£",
			original: "£",
			name: "British Pound Sterling",
		},
		flag: "b/bc/Flag_of_the_Isle_of_Man",
		emoji: "🇮",
		emojiU: "U+1F1EE U+1F1F2",
		coordinates: [54.2361, -4.5481],
	},
	IN: {
		tld: ".in",
		dial: "91",
		currency: {
			code: "INR",
			symbol: "Rs",
			original: "টক",
			name: "Indian Rupee",
		},
		flag: "4/41/Flag_of_India",
		emoji: "🇮",
		emojiU: "U+1F1EE U+1F1F3",
		coordinates: [20.5937, 78.9629],
	},
	IO: {
		tld: ".io",
		dial: "246",
		currency: {
			code: "USD",
			symbol: "$",
			original: "$",
			name: "US Dollar",
		},
		flag: "6/65/Flag_of_the_Commissioner_of_the_British_Indian_Ocean_Territory",
		emoji: "🇮",
		emojiU: "U+1F1EE U+1F1F4",
		coordinates: [-6.3432, 71.8765],
	},
	IQ: {
		tld: ".iq",
		dial: "964",
		currency: {
			code: "IQD",
			symbol: "IQD",
			original: "د.ع.�",
			name: "Iraqi Dinar",
		},
		flag: "f/f6/Flag_of_Iraq",
		emoji: "🇮",
		emojiU: "U+1F1EE U+1F1F6",
		coordinates: [33.2232, 43.6793],
	},
	IR: {
		tld: ".ir",
		dial: "98",
		currency: {
			code: "IRR",
			symbol: "IRR",
			original: "﷼",
			name: "Iranian Rial",
		},
		flag: "c/ca/Flag_of_Iran",
		emoji: "🇮",
		emojiU: "U+1F1EE U+1F1F7",
		coordinates: [32.4279, 53.688],
	},
	IS: {
		tld: ".is",
		dial: "354",
		currency: {
			code: "ISK",
			symbol: "Ikr",
			original: "kr",
			name: "Icelandic Króna",
		},
		flag: "c/ce/Flag_of_Iceland",
		emoji: "🇮",
		emojiU: "U+1F1EE U+1F1F8",
		coordinates: [64.9631, -19.0208],
	},
	IT: {
		tld: ".it",
		dial: "39",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "0/03/Flag_of_Italy",
		emoji: "🇮",
		emojiU: "U+1F1EE U+1F1F9",
		coordinates: [41.8719, 12.5674],
	},
	JE: {
		tld: ".je",
		dial: "44",
		currency: {
			code: "GBP",
			symbol: "£",
			original: "£",
			name: "British Pound Sterling",
		},
		flag: "1/1c/Flag_of_Jersey",
		emoji: "🇯",
		emojiU: "U+1F1EF U+1F1EA",
		coordinates: [49.2144, -2.1313],
	},
	JM: {
		tld: ".jm",
		dial: "1-876",
		currency: {
			code: "JMD",
			symbol: "J$",
			original: "$",
			name: "Jamaican Dollar",
		},
		flag: "0/0a/Flag_of_Jamaica",
		emoji: "🇯",
		emojiU: "U+1F1EF U+1F1F2",
		coordinates: [18.1096, -77.2975],
	},
	JO: {
		tld: ".jo",
		dial: "962",
		currency: {
			code: "JOD",
			symbol: "JD",
			original: "د.أ.�",
			name: "Jordanian Dinar",
		},
		flag: "c/c0/Flag_of_Jordan",
		emoji: "🇯",
		emojiU: "U+1F1EF U+1F1F4",
		coordinates: [30.5852, 36.2384],
	},
	JP: {
		tld: ".jp",
		dial: "81",
		currency: {
			code: "JPY",
			symbol: "¥",
			original: "￥",
			name: "Japanese Yen",
		},
		flag: "b/bc/Flag_of_Japan%28bordered%29",
		emoji: "🇯",
		emojiU: "U+1F1EF U+1F1F5",
		coordinates: [36.2048, 138.2529],
	},
	KE: {
		tld: ".ke",
		dial: "254",
		currency: {
			code: "KES",
			symbol: "Ksh",
			original: "Ksh",
			name: "Kenyan Shilling",
		},
		flag: "4/49/Flag_of_Kenya",
		emoji: "🇰",
		emojiU: "U+1F1F0 U+1F1EA",
		coordinates: [-0.0236, 37.9062],
	},
	KG: {
		tld: ".kg",
		dial: "996",
		currency: {
			code: "KGS",
			name: "Som",
		},
		flag: "c/c7/Flag_of_Kyrgyzstan",
		emoji: "🇰",
		emojiU: "U+1F1F0 U+1F1EC",
		coordinates: [41.2044, 74.7661],
	},
	KH: {
		tld: ".kh",
		dial: "855",
		currency: {
			code: "KHR",
			symbol: "KHR",
			original: "៛",
			name: "Cambodian Riel",
		},
		flag: "8/83/Flag_of_Cambodia",
		emoji: "🇰",
		emojiU: "U+1F1F0 U+1F1ED",
		coordinates: [12.5657, 104.991],
	},
	KI: {
		tld: ".ki",
		dial: "686",
		currency: {
			code: "AUD",
			symbol: "AU$",
			original: "$",
			name: "Australian Dollar",
		},
		flag: "d/d3/Flag_of_Kiribati",
		emoji: "🇰",
		emojiU: "U+1F1F0 U+1F1EE",
		coordinates: [-3.3704, -168.734],
	},
	KM: {
		tld: ".km",
		dial: "269",
		currency: {
			code: "KMF",
			symbol: "CF",
			original: "FC",
			name: "Comorian Franc",
		},
		flag: "d/df/Flag_of_the_Comoros_(3-2)",
		emoji: "🇰",
		emojiU: "U+1F1F0 U+1F1F2",
		coordinates: [-11.875, 43.8722],
	},
	KN: {
		tld: ".kn",
		dial: "1-869",
		currency: {
			code: "XCD",
			name: "East Caribbean Dollar",
		},
		flag: "f/fe/Flag_of_Saint_Kitts_and_Nevis",
		emoji: "🇰",
		emojiU: "U+1F1F0 U+1F1F3",
		coordinates: [17.3578, -62.783],
	},
	KP: {
		tld: ".kp",
		dial: "850",
		currency: {
			code: "KPW",
			name: "North Korean Won",
		},
		flag: "5/51/Flag_of_North_Korea",
		emoji: "🇰",
		emojiU: "U+1F1F0 U+1F1F5",
		coordinates: [40.3399, 127.5101],
	},
	KR: {
		tld: ".kr",
		dial: "82",
		currency: {
			code: "KRW",
			symbol: "₩",
			original: "₩",
			name: "South Korean Won",
		},
		flag: "0/09/Flag_of_South_Korea",
		emoji: "🇰",
		emojiU: "U+1F1F0 U+1F1F7",
		coordinates: [35.9078, 127.7669],
	},
	KW: {
		tld: ".kw",
		dial: "965",
		currency: {
			code: "KWD",
			symbol: "KD",
			original: "د.ك.�",
			name: "Kuwaiti Dinar",
		},
		flag: "a/aa/Flag_of_Kuwait",
		emoji: "🇰",
		emojiU: "U+1F1F0 U+1F1FC",
		coordinates: [29.3117, 47.4818],
	},
	KY: {
		tld: ".ky",
		dial: "1-345",
		currency: {
			code: "KYD",
			name: "Cayman Islands Dollar",
		},
		flag: "0/0f/Flag_of_the_Cayman_Islands",
		emoji: "🇰",
		emojiU: "U+1F1F0 U+1F1FE",
		coordinates: [19.5135, -80.567],
	},
	KZ: {
		tld: ".kz",
		dial: "7",
		currency: {
			code: "KZT",
			symbol: "KZT",
			original: "тңг.",
			name: "Kazakhstani Tenge",
		},
		flag: "d/d3/Flag_of_Kazakhstan",
		emoji: "🇰",
		emojiU: "U+1F1F0 U+1F1FF",
		coordinates: [48.0196, 66.9237],
	},
	LA: {
		tld: ".la",
		dial: "856",
		currency: {
			code: "LAK",
			name: "Lao Kip",
		},
		flag: "5/56/Flag_of_Laos",
		emoji: "🇱",
		emojiU: "U+1F1F1 U+1F1E6",
		coordinates: [19.8563, 102.4955],
	},
	LB: {
		tld: ".lb",
		dial: "961",
		currency: {
			code: "LBP",
			symbol: "L.L.",
			original: "ل.ل.�",
			name: "Lebanese Pound",
		},
		flag: "5/59/Flag_of_Lebanon",
		emoji: "🇱",
		emojiU: "U+1F1F1 U+1F1E7",
		coordinates: [33.8547, 35.8623],
	},
	LC: {
		tld: ".lc",
		dial: "1-758",
		currency: {
			code: "XCD",
			name: "East Caribbean Dollar",
		},
		flag: "9/9f/Flag_of_Saint_Lucia",
		emoji: "🇱",
		emojiU: "U+1F1F1 U+1F1E8",
		coordinates: [13.9094, -60.9789],
	},
	LI: {
		tld: ".li",
		dial: "423",
		currency: {
			code: "CHF",
			symbol: "CHF",
			original: "CHF",
			name: "Swiss Franc",
		},
		flag: "4/47/Flag_of_Liechtenstein",
		emoji: "🇱",
		emojiU: "U+1F1F1 U+1F1EE",
		coordinates: [47.166, 9.5554],
	},
	LK: {
		tld: ".lk",
		dial: "94",
		currency: {
			code: "LKR",
			symbol: "SLRs",
			original: "SL Re",
			name: "Sri Lankan Rupee",
		},
		flag: "1/11/Flag_of_Sri_Lanka",
		emoji: "🇱",
		emojiU: "U+1F1F1 U+1F1F0",
		coordinates: [7.8731, 80.7718],
	},
	LR: {
		tld: ".lr",
		dial: "231",
		currency: {
			code: "LRD",
			name: "Liberian Dollar",
		},
		flag: "b/b8/Flag_of_Liberia",
		emoji: "🇱",
		emojiU: "U+1F1F1 U+1F1F7",
		coordinates: [6.4281, -9.4295],
	},
	LS: {
		tld: ".ls",
		dial: "266",
		currency: {
			code: "LSL,ZAR",
			name: "Loti,Rand",
		},
		flag: "4/4a/Flag_of_Lesotho",
		emoji: "🇱",
		emojiU: "U+1F1F1 U+1F1F8",
		coordinates: [-29.61, 28.2336],
	},
	LT: {
		tld: ".lt",
		dial: "370",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "1/11/Flag_of_Lithuania",
		emoji: "🇱",
		emojiU: "U+1F1F1 U+1F1F9",
		coordinates: [55.1694, 23.8813],
	},
	LU: {
		tld: ".lu",
		dial: "352",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "d/da/Flag_of_Luxembourg",
		emoji: "🇱",
		emojiU: "U+1F1F1 U+1F1FA",
		coordinates: [49.8153, 6.1296],
	},
	LV: {
		tld: ".lv",
		dial: "371",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "8/84/Flag_of_Latvia",
		emoji: "🇱",
		emojiU: "U+1F1F1 U+1F1FB",
		coordinates: [56.8796, 24.6032],
	},
	LY: {
		tld: ".ly",
		dial: "218",
		currency: {
			code: "LYD",
			symbol: "LD",
			original: "د.ل.�",
			name: "Libyan Dinar",
		},
		flag: "0/05/Flag_of_Libya",
		emoji: "🇱",
		emojiU: "U+1F1F1 U+1F1FE",
		coordinates: [26.3351, 17.2283],
	},
	MA: {
		tld: ".ma",
		dial: "212",
		currency: {
			code: "MAD",
			symbol: "MAD",
			original: "د.م.�",
			name: "Moroccan Dirham",
		},
		flag: "2/2c/Flag_of_Morocco",
		emoji: "🇲",
		emojiU: "U+1F1F2 U+1F1E6",
		coordinates: [31.7917, -7.0926],
	},
	MC: {
		tld: ".mc",
		dial: "377",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "e/ea/Flag_of_Monaco",
		emoji: "🇲",
		emojiU: "U+1F1F2 U+1F1E8",
		coordinates: [43.7503, 7.4128],
	},
	MD: {
		tld: ".md",
		dial: "373",
		currency: {
			code: "MDL",
			symbol: "MDL",
			original: "MDL",
			name: "Moldovan Leu",
		},
		flag: "2/27/Flag_of_Moldova",
		emoji: "🇲",
		emojiU: "U+1F1F2 U+1F1E9",
		coordinates: [47.4116, 28.3699],
	},
	ME: {
		tld: ".me",
		dial: "382",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "6/64/Flag_of_Montenegro",
		emoji: "🇲",
		emojiU: "U+1F1F2 U+1F1EA",
		coordinates: [42.7087, 19.3744],
	},
	MF: {
		tld: ".gp",
		dial: "590",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "d/dd/Flag_of_Saint-Martin_%28fictional%29",
		emoji: "🇲",
		emojiU: "U+1F1F2 U+1F1EB",
		coordinates: [18.0708, 63.0501],
	},
	MG: {
		tld: ".mg",
		dial: "261",
		currency: {
			code: "MGA",
			symbol: "MGA",
			original: "MGA",
			name: "Malagasy Ariary",
		},
		flag: "b/bc/Flag_of_Madagascar",
		emoji: "🇲",
		emojiU: "U+1F1F2 U+1F1EC",
		coordinates: [-18.7669, 46.8691],
	},
	MH: {
		tld: ".mh",
		dial: "692",
		currency: {
			code: "USD",
			symbol: "$",
			original: "$",
			name: "US Dollar",
		},
		flag: "2/2e/Flag_of_the_Marshall_Islands",
		emoji: "🇲",
		emojiU: "U+1F1F2 U+1F1ED",
		coordinates: [7.1315, 171.1845],
	},
	MK: {
		tld: ".mk",
		dial: "389",
		currency: {
			code: "MKD",
			symbol: "MKD",
			original: "MKD",
			name: "Macedonian Denar",
		},
		flag: "7/79/Flag_of_North_Macedonia",
		emoji: "🇲",
		emojiU: "U+1F1F2 U+1F1F0",
		coordinates: [41.6086, 21.7453],
	},
	ML: {
		tld: ".ml",
		dial: "223",
		currency: {
			code: "XOF",
			symbol: "CFA",
			original: "CFA",
			name: "CFA Franc BCEAO",
		},
		flag: "9/92/Flag_of_Mali",
		emoji: "🇲",
		emojiU: "U+1F1F2 U+1F1F1",
		coordinates: [17.5707, -3.9962],
	},
	MM: {
		tld: ".mm",
		dial: "95",
		currency: {
			code: "MMK",
			symbol: "MMK",
			original: "K",
			name: "Myanma Kyat",
		},
		flag: "8/8c/Flag_of_Myanmar",
		emoji: "🇲",
		emojiU: "U+1F1F2 U+1F1F2",
		coordinates: [21.914, 95.9562],
	},
	MN: {
		tld: ".mn",
		dial: "976",
		currency: {
			code: "MNT",
			name: "Tugrik",
		},
		flag: "4/4c/Flag_of_Mongolia",
		emoji: "🇲",
		emojiU: "U+1F1F2 U+1F1F3",
		coordinates: [46.8625, 103.8467],
	},
	MO: {
		tld: ".mo",
		dial: "853",
		currency: {
			code: "MOP",
			symbol: "MOP$",
			original: "MOP$",
			name: "Macanese Pataca",
		},
		flag: "6/63/Flag_of_Macau",
		emoji: "🇲",
		emojiU: "U+1F1F2 U+1F1F4",
		coordinates: [22.1987, 113.5439],
	},
	MP: {
		tld: ".mp",
		dial: "1-670",
		currency: {
			code: "USD",
			symbol: "$",
			original: "$",
			name: "US Dollar",
		},
		flag: "e/e0/Flag_of_the_Northern_Mariana_Islands",
		emoji: "🇲",
		emojiU: "U+1F1F2 U+1F1F5",
		coordinates: [17.3308, 145.3847],
	},
	MQ: {
		tld: ".mq",
		dial: "596",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "2/21/Flag_of_the_Territorial_Collectivity_of_Martinique",
		emoji: "🇲",
		emojiU: "U+1F1F2 U+1F1F6",
		coordinates: [14.6415, -61.0242],
	},
	MR: {
		tld: ".mr",
		dial: "222",
		currency: {
			code: "MRU",
			name: "Ouguiya",
		},
		flag: "4/43/Flag_of_Mauritania",
		emoji: "🇲",
		emojiU: "U+1F1F2 U+1F1F7",
		coordinates: [21.0079, -10.9408],
	},
	MS: {
		tld: ".ms",
		dial: "1-664",
		currency: {
			code: "XCD",
			name: "East Caribbean Dollar",
		},
		flag: "d/d0/Flag_of_Montserrat",
		emoji: "🇲",
		emojiU: "U+1F1F2 U+1F1F8",
		coordinates: [16.7425, -62.1874],
	},
	MT: {
		tld: ".mt",
		dial: "356",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "7/73/Flag_of_Malta",
		emoji: "🇲",
		emojiU: "U+1F1F2 U+1F1F9",
		coordinates: [35.9375, 14.3754],
	},
	MU: {
		tld: ".mu",
		dial: "230",
		currency: {
			code: "MUR",
			symbol: "MURs",
			original: "MURs",
			name: "Mauritian Rupee",
		},
		flag: "7/77/Flag_of_Mauritius",
		emoji: "🇲",
		emojiU: "U+1F1F2 U+1F1FA",
		coordinates: [-20.3484, 57.5522],
	},
	MV: {
		tld: ".mv",
		dial: "960",
		currency: {
			code: "MVR",
			name: "Rufiyaa",
		},
		flag: "0/0f/Flag_of_Maldives",
		emoji: "🇲",
		emojiU: "U+1F1F2 U+1F1FB",
		coordinates: [3.2028, 73.2207],
	},
	MW: {
		tld: ".mw",
		dial: "265",
		currency: {
			code: "MWK",
			name: "Malawi Kwacha",
		},
		flag: "d/d1/Flag_of_Malawi",
		emoji: "🇲",
		emojiU: "U+1F1F2 U+1F1FC",
		coordinates: [-13.2543, 34.3015],
	},
	MX: {
		tld: ".mx",
		dial: "52",
		currency: {
			code: "MXN",
			symbol: "MX$",
			original: "$",
			name: "Mexican Peso",
		},
		flag: "f/fc/Flag_of_Mexico",
		emoji: "🇲",
		emojiU: "U+1F1F2 U+1F1FD",
		coordinates: [23.6345, -102.5528],
	},
	MY: {
		tld: ".my",
		dial: "60",
		currency: {
			code: "MYR",
			symbol: "RM",
			original: "RM",
			name: "Malaysian Ringgit",
		},
		flag: "6/66/Flag_of_Malaysia",
		emoji: "🇲",
		emojiU: "U+1F1F2 U+1F1FE",
		coordinates: [4.2105, 101.9758],
	},
	MZ: {
		tld: ".mz",
		dial: "258",
		currency: {
			code: "MZN",
			symbol: "MTn",
			original: "MTn",
			name: "Mozambican Metical",
		},
		flag: "d/d0/Flag_of_Mozambique",
		emoji: "🇲",
		emojiU: "U+1F1F2 U+1F1FF",
		coordinates: [-18.6657, 35.5296],
	},
	NA: {
		tld: ".na",
		dial: "264",
		currency: {
			code: "NAD,ZAR",
			name: "Namibia Dollar,Rand",
		},
		flag: "0/00/Flag_of_Namibia",
		emoji: "🇳",
		emojiU: "U+1F1F3 U+1F1E6",
		coordinates: [-22.9576, 18.4904],
	},
	NC: {
		tld: ".nc",
		dial: "687",
		currency: {
			code: "XPF",
			name: "CFP Franc",
		},
		flag: "6/66/Flag_of_FLNKS",
		emoji: "🇳",
		emojiU: "U+1F1F3 U+1F1E8",
		coordinates: [-20.9043, 165.618],
	},
	NE: {
		tld: ".ne",
		dial: "227",
		currency: {
			code: "XOF",
			symbol: "CFA",
			original: "CFA",
			name: "CFA Franc BCEAO",
		},
		flag: "f/f4/Flag_of_Niger",
		emoji: "🇳",
		emojiU: "U+1F1F3 U+1F1EA",
		coordinates: [17.6078, 8.0817],
	},
	NF: {
		tld: ".nf",
		dial: "672",
		currency: {
			code: "AUD",
			symbol: "AU$",
			original: "$",
			name: "Australian Dollar",
		},
		flag: "4/48/Flag_of_Norfolk_Island",
		emoji: "🇳",
		emojiU: "U+1F1F3 U+1F1EB",
		coordinates: [-29.0408, 167.9547],
	},
	NG: {
		tld: ".ng",
		dial: "234",
		currency: {
			code: "NGN",
			symbol: "₦",
			original: "₦",
			name: "Nigerian Naira",
		},
		flag: "7/79/Flag_of_Nigeria",
		emoji: "🇳",
		emojiU: "U+1F1F3 U+1F1EC",
		coordinates: [9.082, 8.6753],
	},
	NI: {
		tld: ".ni",
		dial: "505",
		currency: {
			code: "NIO",
			symbol: "C$",
			original: "C$",
			name: "Nicaraguan Córdoba",
		},
		flag: "1/19/Flag_of_Nicaragua",
		emoji: "🇳",
		emojiU: "U+1F1F3 U+1F1EE",
		coordinates: [12.8654, -85.2072],
	},
	NL: {
		tld: ".nl",
		dial: "31",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "2/20/Flag_of_the_Netherlands",
		emoji: "🇳",
		emojiU: "U+1F1F3 U+1F1F1",
		coordinates: [52.1326, 5.2913],
	},
	NO: {
		tld: ".no",
		dial: "47",
		currency: {
			code: "NOK",
			symbol: "Nkr",
			original: "kr",
			name: "Norwegian Krone",
		},
		flag: "d/d9/Flag_of_Norway",
		emoji: "🇳",
		emojiU: "U+1F1F3 U+1F1F4",
		coordinates: [60.472, 8.4689],
	},
	NP: {
		tld: ".np",
		dial: "977",
		currency: {
			code: "NPR",
			symbol: "NPRs",
			original: "नर",
			name: "Nepalese Rupee",
		},
		flag: "9/9b/Flag_of_Nepal",
		emoji: "🇳",
		emojiU: "U+1F1F3 U+1F1F5",
		coordinates: [28.3949, 84.124],
	},
	NR: {
		tld: ".nr",
		dial: "674",
		currency: {
			code: "AUD",
			symbol: "AU$",
			original: "$",
			name: "Australian Dollar",
		},
		flag: "3/30/Flag_of_Nauru",
		emoji: "🇳",
		emojiU: "U+1F1F3 U+1F1F7",
		coordinates: [-0.5228, 166.9315],
	},
	NU: {
		tld: ".nu",
		dial: "683",
		currency: {
			code: "NZD",
			symbol: "NZ$",
			original: "$",
			name: "New Zealand Dollar",
		},
		flag: "0/01/Flag_of_Niue",
		emoji: "🇳",
		emojiU: "U+1F1F3 U+1F1FA",
		coordinates: [-19.0544, -169.8672],
	},
	NZ: {
		tld: ".nz",
		dial: "64",
		currency: {
			code: "NZD",
			symbol: "NZ$",
			original: "$",
			name: "New Zealand Dollar",
		},
		flag: "3/3e/Flag_of_New_Zealand",
		emoji: "🇳",
		emojiU: "U+1F1F3 U+1F1FF",
		coordinates: [-40.9006, 174.886],
	},
	OM: {
		tld: ".om",
		dial: "968",
		currency: {
			code: "OMR",
			symbol: "OMR",
			original: "ر.ع.�",
			name: "Omani Rial",
		},
		flag: "d/dd/Flag_of_Oman",
		emoji: "🇴",
		emojiU: "U+1F1F4 U+1F1F2",
		coordinates: [21.5126, 55.9233],
	},
	PA: {
		tld: ".pa",
		dial: "507",
		currency: {
			code: "PAB,USD",
			name: "Balboa,US Dollar",
		},
		flag: "a/ab/Flag_of_Panama",
		emoji: "🇵",
		emojiU: "U+1F1F5 U+1F1E6",
		coordinates: [8.538, -80.7821],
	},
	PE: {
		tld: ".pe",
		dial: "51",
		currency: {
			code: "PEN",
			symbol: "S/.",
			original: "S/.",
			name: "Peruvian Nuevo Sol",
		},
		flag: "c/cf/Flag_of_Peru",
		emoji: "🇵",
		emojiU: "U+1F1F5 U+1F1EA",
		coordinates: [-9.19, -75.0152],
	},
	PF: {
		tld: ".pf",
		dial: "689",
		currency: {
			code: "XPF",
			name: "CFP Franc",
		},
		flag: "d/db/Flag_of_French_Polynesia",
		emoji: "🇵",
		emojiU: "U+1F1F5 U+1F1EB",
		coordinates: [-17.6797, -149.4068],
	},
	PG: {
		tld: ".pg",
		dial: "675",
		currency: {
			code: "PGK",
			name: "Kina",
		},
		flag: "e/e3/Flag_of_Papua_New_Guinea",
		emoji: "🇵",
		emojiU: "U+1F1F5 U+1F1EC",
		coordinates: [-6.315, 143.9555],
	},
	PH: {
		tld: ".ph",
		dial: "63",
		currency: {
			code: "PHP",
			symbol: "₱",
			original: "₱",
			name: "Philippine Peso",
		},
		flag: "9/99/Flag_of_the_Philippines",
		emoji: "🇵",
		emojiU: "U+1F1F5 U+1F1ED",
		coordinates: [12.8797, 121.774],
	},
	PK: {
		tld: ".pk",
		dial: "92",
		currency: {
			code: "PKR",
			symbol: "PKRs",
			original: "₨",
			name: "Pakistani Rupee",
		},
		flag: "3/32/Flag_of_Pakistan",
		emoji: "🇵",
		emojiU: "U+1F1F5 U+1F1F0",
		coordinates: [30.3753, 69.3451],
	},
	PL: {
		tld: ".pl",
		dial: "48",
		currency: {
			code: "PLN",
			symbol: "zł",
			original: "zł",
			name: "Polish Zloty",
		},
		flag: "1/12/Flag_of_Poland",
		emoji: "🇵",
		emojiU: "U+1F1F5 U+1F1F1",
		coordinates: [51.9194, 19.1451],
	},
	PM: {
		tld: ".pm",
		dial: "508",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "7/74/Flag_of_Saint-Pierre_and_Miquelon",
		emoji: "🇵",
		emojiU: "U+1F1F5 U+1F1F2",
		coordinates: [46.9419, -56.2711],
	},
	PN: {
		tld: ".pn",
		dial: "870",
		currency: {
			code: "NZD",
			symbol: "NZ$",
			original: "$",
			name: "New Zealand Dollar",
		},
		flag: "8/88/Flag_of_the_Pitcairn_Islands",
		emoji: "🇵",
		emojiU: "U+1F1F5 U+1F1F3",
		coordinates: [-24.7036, -127.4393],
	},
	PR: {
		tld: ".pr",
		dial: "1",
		currency: {
			code: "USD",
			symbol: "$",
			original: "$",
			name: "US Dollar",
		},
		flag: "2/28/Flag_of_Puerto_Rico",
		emoji: "🇵",
		emojiU: "U+1F1F5 U+1F1F7",
		coordinates: [18.2208, -66.5901],
	},
	PS: {
		tld: ".ps",
		dial: "970",
		currency: {
			name: "No universal currency",
		},
		flag: "f/f4/Palestine_Flag",
		emoji: "🇵",
		emojiU: "U+1F1F5 U+1F1F8",
		coordinates: [31.9522, 35.2332],
	},
	PT: {
		tld: ".pt",
		dial: "351",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "5/5c/Flag_of_Portugal",
		emoji: "🇵",
		emojiU: "U+1F1F5 U+1F1F9",
		coordinates: [39.3999, -8.2245],
	},
	PW: {
		tld: ".pw",
		dial: "680",
		currency: {
			code: "USD",
			symbol: "$",
			original: "$",
			name: "US Dollar",
		},
		flag: "4/48/Flag_of_Palau",
		emoji: "🇵",
		emojiU: "U+1F1F5 U+1F1FC",
		coordinates: [7.515, 134.5825],
	},
	PY: {
		tld: ".py",
		dial: "595",
		currency: {
			code: "PYG",
			symbol: "₲",
			original: "₲",
			name: "Paraguayan Guarani",
		},
		flag: "2/27/Flag_of_Paraguay",
		emoji: "🇵",
		emojiU: "U+1F1F5 U+1F1FE",
		coordinates: [-23.4425, -58.4438],
	},
	QA: {
		tld: ".qa",
		dial: "974",
		currency: {
			code: "QAR",
			symbol: "QR",
			original: "ر.ق.�",
			name: "Qatari Rial",
		},
		flag: "6/65/Flag_of_Qatar",
		emoji: "🇶",
		emojiU: "U+1F1F6 U+1F1E6",
		coordinates: [25.3548, 51.1839],
	},
	RE: {
		tld: ".re",
		dial: "262",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "5/5a/Flag_of_Réunion",
		emoji: "🇷",
		emojiU: "U+1F1F7 U+1F1EA",
		coordinates: [-21.1151, 55.5364],
	},
	RO: {
		tld: ".ro",
		dial: "40",
		currency: {
			code: "RON",
			symbol: "RON",
			original: "RON",
			name: "Romanian Leu",
		},
		flag: "7/73/Flag_of_Romania",
		emoji: "🇷",
		emojiU: "U+1F1F7 U+1F1F4",
		coordinates: [45.9432, 24.9668],
	},
	RS: {
		tld: ".rs",
		dial: "381",
		currency: {
			code: "RSD",
			symbol: "din.",
			original: "дин.",
			name: "Serbian Dinar",
		},
		flag: "f/ff/Flag_of_Serbia",
		emoji: "🇷",
		emojiU: "U+1F1F7 U+1F1F8",
		coordinates: [44.0165, 21.0059],
	},
	RU: {
		tld: ".ru",
		dial: "7",
		currency: {
			code: "RUB",
			symbol: "RUB",
			original: "₽.",
			name: "Russian Ruble",
		},
		flag: "f/f3/Flag_of_Russia",
		emoji: "🇷",
		emojiU: "U+1F1F7 U+1F1FA",
		coordinates: [61.524, 105.3188],
	},
	RW: {
		tld: ".rw",
		dial: "250",
		currency: {
			code: "RWF",
			symbol: "RWF",
			original: "FR",
			name: "Rwandan Franc",
		},
		flag: "1/17/Flag_of_Rwanda",
		emoji: "🇷",
		emojiU: "U+1F1F7 U+1F1FC",
		coordinates: [-1.9403, 29.8739],
	},
	SA: {
		tld: ".sa",
		dial: "966",
		currency: {
			code: "SAR",
			symbol: "SR",
			original: "ر.س.�",
			name: "Saudi Riyal",
		},
		flag: "0/0d/Flag_of_Saudi_Arabia",
		emoji: "🇸",
		emojiU: "U+1F1F8 U+1F1E6",
		coordinates: [23.8859, 45.0792],
	},
	SB: {
		tld: ".sb",
		dial: "677",
		currency: {
			code: "SBD",
			name: "Solomon Islands Dollar",
		},
		flag: "7/74/Flag_of_the_Solomon_Islands",
		emoji: "🇸",
		emojiU: "U+1F1F8 U+1F1E7",
		coordinates: [-9.6457, 160.1562],
	},
	SC: {
		tld: ".sc",
		dial: "248",
		currency: {
			code: "SCR",
			name: "Seychelles Rupee",
		},
		flag: "f/fc/Flag_of_Seychelles",
		emoji: "🇸",
		emojiU: "U+1F1F8 U+1F1E8",
		coordinates: [-4.6796, 55.492],
	},
	SD: {
		tld: ".sd",
		dial: "249",
		currency: {
			code: "SDG",
			symbol: "SDG",
			original: "SDG",
			name: "Sudanese Pound",
		},
		flag: "0/01/Flag_of_Sudan",
		emoji: "🇸",
		emojiU: "U+1F1F8 U+1F1E9",
		coordinates: [12.8628, 30.2176],
	},
	SE: {
		tld: ".se",
		dial: "46",
		currency: {
			code: "SEK",
			symbol: "Skr",
			original: "kr",
			name: "Swedish Krona",
		},
		flag: "4/4c/Flag_of_Sweden",
		emoji: "🇸",
		emojiU: "U+1F1F8 U+1F1EA",
		coordinates: [60.1282, 18.6435],
	},
	SG: {
		tld: ".sg",
		dial: "65",
		currency: {
			code: "SGD",
			symbol: "S$",
			original: "$",
			name: "Singapore Dollar",
		},
		flag: "4/48/Flag_of_Singapore",
		emoji: "🇸",
		emojiU: "U+1F1F8 U+1F1EC",
		coordinates: [1.3521, 103.8198],
	},
	SH: {
		tld: ".sh",
		dial: "290",
		currency: {
			code: "SHP",
			name: "Saint Helena Pound",
		},
		flag: "0/00/Flag_of_Saint_Helena",
		emoji: "🇸",
		emojiU: "U+1F1F8 U+1F1ED",
		coordinates: [-24.1435, -10.0307],
	},
	SI: {
		tld: ".si",
		dial: "386",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "f/f0/Flag_of_Slovenia",
		emoji: "🇸",
		emojiU: "U+1F1F8 U+1F1EE",
		coordinates: [46.1512, 14.9955],
	},
	SJ: {
		tld: ".sj",
		dial: "47",
		currency: {
			code: "NOK",
			symbol: "Nkr",
			original: "kr",
			name: "Norwegian Krone",
		},
		flag: "d/d9/Flag_of_Norway",
		emoji: "🇸",
		emojiU: "U+1F1F8 U+1F1EF",
		coordinates: [77.5536, 23.6703],
	},
	SK: {
		tld: ".sk",
		dial: "421",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "e/e6/Flag_of_Slovakia",
		emoji: "🇸",
		emojiU: "U+1F1F8 U+1F1F0",
		coordinates: [48.669, 19.699],
	},
	SL: {
		tld: ".sl",
		dial: "232",
		currency: {
			code: "SLL",
			name: "Leone",
		},
		flag: "1/17/Flag_of_Sierra_Leone",
		emoji: "🇸",
		emojiU: "U+1F1F8 U+1F1F1",
		coordinates: [8.4606, -11.7799],
	},
	SM: {
		tld: ".sm",
		dial: "378",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "b/b1/Flag_of_San_Marino",
		emoji: "🇸",
		emojiU: "U+1F1F8 U+1F1F2",
		coordinates: [43.9424, 12.4578],
	},
	SN: {
		tld: ".sn",
		dial: "221",
		currency: {
			code: "XOF",
			symbol: "CFA",
			original: "CFA",
			name: "CFA Franc BCEAO",
		},
		flag: "f/fd/Flag_of_Senegal",
		emoji: "🇸",
		emojiU: "U+1F1F8 U+1F1F3",
		coordinates: [14.4974, -14.4524],
	},
	SO: {
		tld: ".so",
		dial: "252",
		currency: {
			code: "SOS",
			symbol: "Ssh",
			original: "Ssh",
			name: "Somali Shilling",
		},
		flag: "a/a0/Flag_of_Somalia",
		emoji: "🇸",
		emojiU: "U+1F1F8 U+1F1F4",
		coordinates: [5.1521, 46.1996],
	},
	SR: {
		tld: ".sr",
		dial: "597",
		currency: {
			code: "SRD",
			name: "Surinam Dollar",
		},
		flag: "6/60/Flag_of_Suriname",
		emoji: "🇸",
		emojiU: "U+1F1F8 U+1F1F7",
		coordinates: [3.9193, -56.0278],
	},
	SS: {
		dial: "211",
		currency: {
			code: "SSP",
			name: "South Sudanese Pound",
		},
		flag: "7/7a/Flag_of_South_Sudan",
		emoji: "🇸",
		emojiU: "U+1F1F8 U+1F1F8",
		coordinates: [6.877, 31.307],
	},
	ST: {
		tld: ".st",
		dial: "239",
		currency: {
			code: "STN",
			name: "Dobra",
		},
		flag: "4/4f/Flag_of_Sao_Tome_and_Principe",
		emoji: "🇸",
		emojiU: "U+1F1F8 U+1F1F9",
		coordinates: [0.1864, 6.6131],
	},
	SV: {
		tld: ".sv",
		dial: "503",
		currency: {
			code: "SVC,USD",
			name: "El Salvador Colon,US Dollar",
		},
		flag: "3/34/Flag_of_El_Salvador",
		emoji: "🇸",
		emojiU: "U+1F1F8 U+1F1FB",
		coordinates: [13.7942, -88.8965],
	},
	SX: {
		tld: ".sx",
		dial: "1-721",
		currency: {
			code: "ANG",
			name: "Netherlands Antillean Guilder",
		},
		flag: "d/d3/Flag_of_Sint_Maarten",
		emoji: "🇸",
		emojiU: "U+1F1F8 U+1F1FD",
		coordinates: [18.086, 63.0619],
	},
	SY: {
		tld: ".sy",
		dial: "963",
		currency: {
			code: "SYP",
			symbol: "SY£",
			original: "ل.س.�",
			name: "Syrian Pound",
		},
		flag: "5/53/Flag_of_Syria",
		emoji: "🇸",
		emojiU: "U+1F1F8 U+1F1FE",
		coordinates: [34.8021, 38.9968],
	},
	SZ: {
		tld: ".sz",
		dial: "268",
		currency: {
			code: "SZL",
			name: "Lilangeni",
		},
		flag: "f/fb/Flag_of_Eswatini",
		emoji: "🇸",
		emojiU: "U+1F1F8 U+1F1FF",
		coordinates: [-26.5225, 31.4659],
	},
	TC: {
		tld: ".tc",
		dial: "1-649",
		currency: {
			code: "USD",
			symbol: "$",
			original: "$",
			name: "US Dollar",
		},
		flag: "a/a0/Flag_of_the_Turks_and_Caicos_Islands",
		emoji: "🇹",
		emojiU: "U+1F1F9 U+1F1E8",
		coordinates: [21.694, -71.7979],
	},
	TD: {
		tld: ".td",
		dial: "235",
		currency: {
			code: "XAF",
			symbol: "FCFA",
			original: "FCFA",
			name: "CFA Franc BEAC",
		},
		flag: "4/4b/Flag_of_Chad",
		emoji: "🇹",
		emojiU: "U+1F1F9 U+1F1E9",
		coordinates: [15.4542, 18.7322],
	},
	TF: {
		tld: ".tf",
		dial: "262",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "d/d8/Flag_of_the_Senior_Administrator_of_the_French_Southern_and_Antarctic_Lands",
		emoji: "🇹",
		emojiU: "U+1F1F9 U+1F1EB",
		coordinates: [-49.2804, 69.3486],
	},
	TG: {
		tld: ".tg",
		dial: "228",
		currency: {
			code: "XOF",
			symbol: "CFA",
			original: "CFA",
			name: "CFA Franc BCEAO",
		},
		flag: "6/68/Flag_of_Togo",
		emoji: "🇹",
		emojiU: "U+1F1F9 U+1F1EC",
		coordinates: [8.6195, 0.8248],
	},
	TH: {
		tld: ".th",
		dial: "66",
		currency: {
			code: "THB",
			symbol: "฿",
			original: "฿",
			name: "Thai Baht",
		},
		flag: "a/a9/Flag_of_Thailand",
		emoji: "🇹",
		emojiU: "U+1F1F9 U+1F1ED",
		coordinates: [15.87, 100.9925],
	},
	TJ: {
		tld: ".tj",
		dial: "992",
		currency: {
			code: "TJS",
			name: "Somoni",
		},
		flag: "d/d0/Flag_of_Tajikistan",
		emoji: "🇹",
		emojiU: "U+1F1F9 U+1F1EF",
		coordinates: [38.861, 71.2761],
	},
	TK: {
		tld: ".tk",
		dial: "690",
		currency: {
			code: "NZD",
			symbol: "NZ$",
			original: "$",
			name: "New Zealand Dollar",
		},
		flag: "8/8e/Flag_of_Tokelau",
		emoji: "🇹",
		emojiU: "U+1F1F9 U+1F1F0",
		coordinates: [-8.9674, -171.8559],
	},
	TL: {
		tld: ".tl",
		dial: "670",
		currency: {
			code: "USD",
			symbol: "$",
			original: "$",
			name: "US Dollar",
		},
		flag: "2/26/Flag_of_East_Timor",
		emoji: "🇹",
		emojiU: "U+1F1F9 U+1F1F1",
		coordinates: [-8.8742, 125.7275],
	},
	TM: {
		tld: ".tm",
		dial: "993",
		currency: {
			code: "TMT",
			name: "Turkmenistan New Manat",
		},
		flag: "1/1b/Flag_of_Turkmenistan",
		emoji: "🇹",
		emojiU: "U+1F1F9 U+1F1F2",
		coordinates: [38.9697, 59.5563],
	},
	TN: {
		tld: ".tn",
		dial: "216",
		currency: {
			code: "TND",
			symbol: "DT",
			original: "د.ت.�",
			name: "Tunisian Dinar",
		},
		flag: "c/ce/Flag_of_Tunisia",
		emoji: "🇹",
		emojiU: "U+1F1F9 U+1F1F3",
		coordinates: [33.8869, 9.5375],
	},
	TO: {
		tld: ".to",
		dial: "676",
		currency: {
			code: "TOP",
			symbol: "T$",
			original: "T$",
			name: "Tongan Paʻanga",
		},
		flag: "9/9a/Flag_of_Tonga",
		emoji: "🇹",
		emojiU: "U+1F1F9 U+1F1F4",
		coordinates: [-21.179, -175.1982],
	},
	TR: {
		tld: ".tr",
		dial: "90",
		currency: {
			code: "TRY",
			symbol: "TL",
			original: "TL",
			name: "Turkish Lira",
		},
		flag: "b/b4/Flag_of_Turkey",
		emoji: "🇹",
		emojiU: "U+1F1F9 U+1F1F7",
		coordinates: [38.9637, 35.2433],
	},
	TT: {
		tld: ".tt",
		dial: "1-868",
		currency: {
			code: "TTD",
			symbol: "TT$",
			original: "$",
			name: "Trinidad and Tobago Dollar",
		},
		flag: "6/64/Flag_of_Trinidad_and_Tobago",
		emoji: "🇹",
		emojiU: "U+1F1F9 U+1F1F9",
		coordinates: [10.6918, -61.2225],
	},
	TV: {
		tld: ".tv",
		dial: "688",
		currency: {
			code: "AUD",
			symbol: "AU$",
			original: "$",
			name: "Australian Dollar",
		},
		flag: "3/38/Flag_of_Tuvalu",
		emoji: "🇹",
		emojiU: "U+1F1F9 U+1F1FB",
		coordinates: [-7.1095, 177.6493],
	},
	TW: {
		tld: ".tw",
		dial: "886",
		flag: "7/72/Flag_of_the_Republic_of_China",
		currency: {
			code: "TWD",
			symbol: "NT$",
			original: "元",
			name: "New Taiwan dollar",
		},
		emoji: "🇹",
		emojiU: "U+1F1F9 U+1F1FC",
		coordinates: [23.6978, 120.9605],
	},
	TZ: {
		tld: ".tz",
		dial: "255",
		currency: {
			code: "TZS",
			symbol: "TSh",
			original: "TSh",
			name: "Tanzanian Shilling",
		},
		flag: "3/38/Flag_of_Tanzania",
		emoji: "🇹",
		emojiU: "U+1F1F9 U+1F1FF",
		coordinates: [-6.369, 34.8888],
	},
	UA: {
		tld: ".ua",
		dial: "380",
		currency: {
			code: "UAH",
			symbol: "₴",
			original: "₴",
			name: "Ukrainian Hryvnia",
		},
		flag: "4/49/Flag_of_Ukraine",
		emoji: "🇺",
		emojiU: "U+1F1FA U+1F1E6",
		coordinates: [48.3794, 31.1656],
	},
	UG: {
		tld: ".ug",
		dial: "256",
		currency: {
			code: "UGX",
			symbol: "USh",
			original: "USh",
			name: "Ugandan Shilling",
		},
		flag: "4/4e/Flag_of_Uganda",
		emoji: "🇺",
		emojiU: "U+1F1FA U+1F1EC",
		coordinates: [1.3733, 32.2903],
	},
	UM: {
		tld: ".um",
		currency: {
			code: "USD",
			symbol: "$",
			original: "$",
			name: "US Dollar",
		},
		flag: "0/05/Flag_of_the_U.S.",
		emoji: "🇺",
		emojiU: "U+1F1FA U+1F1F2",
		coordinates: [28.2167, -177.3667],
	},
	US: {
		tld: ".us",
		dial: "1",
		currency: {
			code: "USD",
			symbol: "$",
			original: "$",
			name: "US Dollar",
		},
		flag: "a/a4/Flag_of_the_United_States",
		emoji: "🇺",
		emojiU: "U+1F1FA U+1F1F8",
		coordinates: [37.0902, -95.7129],
	},
	UY: {
		tld: ".uy",
		dial: "598",
		currency: {
			code: "UYU",
			symbol: "$U",
			original: "$",
			name: "Uruguayan Peso",
		},
		flag: "f/fe/Flag_of_Uruguay",
		emoji: "🇺",
		emojiU: "U+1F1FA U+1F1FE",
		coordinates: [-32.5228, -55.7658],
	},
	UZ: {
		tld: ".uz",
		dial: "998",
		currency: {
			code: "UZS",
			symbol: "UZS",
			original: "UZS",
			name: "Uzbekistan Som",
		},
		flag: "8/84/Flag_of_Uzbekistan",
		emoji: "🇺",
		emojiU: "U+1F1FA U+1F1FF",
		coordinates: [41.3775, 64.5853],
	},
	VA: {
		tld: ".va",
		dial: "39-06",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "0/00/Flag_of_the_Vatican_City",
		emoji: "🇻",
		emojiU: "U+1F1FB U+1F1E6",
		coordinates: [41.9029, 12.4534],
	},
	VC: {
		tld: ".vc",
		dial: "1-784",
		currency: {
			code: "XCD",
			name: "East Caribbean Dollar",
		},
		flag: "6/6d/Flag_of_Saint_Vincent_and_the_Grenadines",
		emoji: "🇻",
		emojiU: "U+1F1FB U+1F1E8",
		coordinates: [12.9843, -61.2872],
	},
	VE: {
		tld: ".ve",
		dial: "58",
		currency: {
			code: "VES",
			name: "Bol\\u00edvar",
		},
		flag: "7/7b/Flag_of_Venezuela_(state)",
		emoji: "🇻",
		emojiU: "U+1F1FB U+1F1EA",
		coordinates: [6.4238, -66.5897],
	},
	VG: {
		tld: ".vg",
		dial: "1-284",
		currency: {
			code: "USD",
			symbol: "$",
			original: "$",
			name: "US Dollar",
		},
		flag: "4/42/Flag_of_the_British_Virgin_Islands",
		emoji: "🇻",
		emojiU: "U+1F1FB U+1F1EC",
		coordinates: [18.4207, -64.64],
	},
	VI: {
		tld: ".vi",
		dial: "1-340",
		currency: {
			code: "USD",
			symbol: "$",
			original: "$",
			name: "US Dollar",
		},
		flag: "f/f8/Flag_of_the_United_States_Virgin_Islands",
		emoji: "🇻",
		emojiU: "U+1F1FB U+1F1EE",
		coordinates: [18.3358, -64.8963],
	},
	VN: {
		tld: ".vn",
		dial: "84",
		currency: {
			code: "VND",
			symbol: "₫",
			original: "₫",
			name: "Vietnamese Dong",
		},
		flag: "2/21/Flag_of_Vietnam",
		emoji: "🇻",
		emojiU: "U+1F1FB U+1F1F3",
		coordinates: [14.0583, 108.2772],
	},
	VU: {
		tld: ".vu",
		dial: "678",
		currency: {
			code: "VUV",
			name: "Vatu",
		},
		flag: "6/6e/Flag_of_Vanuatu_(official)",
		emoji: "🇻",
		emojiU: "U+1F1FB U+1F1FA",
		coordinates: [-15.3767, 166.9592],
	},
	WF: {
		tld: ".wf",
		dial: "681",
		currency: {
			code: "XPF",
			name: "CFP Franc",
		},
		flag: "d/d2/Flag_of_Wallis_and_Futuna",
		emoji: "🇼",
		emojiU: "U+1F1FC U+1F1EB",
		coordinates: [-13.7688, -177.1561],
	},
	WS: {
		tld: ".ws",
		dial: "685",
		currency: {
			code: "WST",
			name: "Tala",
		},
		flag: "3/31/Flag_of_Samoa",
		emoji: "🇼",
		emojiU: "U+1F1FC U+1F1F8",
		coordinates: [-13.759, -172.1046],
	},
	XK: {
		tld: ".xk",
		dial: "383",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "1/1f/Flag_of_Kosovo",
		emoji: "🇽",
		emojiU: "U+1F1FD U+1F1F0",
		coordinates: [42.6026, 20.903],
	},
	YE: {
		tld: ".ye",
		dial: "967",
		currency: {
			code: "YER",
			symbol: "YR",
			original: "ر.ي.�",
			name: "Yemeni Rial",
		},
		flag: "8/89/Flag_of_Yemen",
		emoji: "🇾",
		emojiU: "U+1F1FE U+1F1EA",
		coordinates: [15.5527, 48.5164],
	},
	YT: {
		tld: ".yt",
		dial: "262",
		currency: {
			code: "EUR",
			symbol: "€",
			original: "€",
			name: "Euro",
		},
		flag: "c/c3/Flag_of_France",
		emoji: "🇾",
		emojiU: "U+1F1FE U+1F1F9",
		coordinates: [-12.8275, 45.1662],
	},
	ZA: {
		tld: ".za",
		dial: "27",
		currency: {
			code: "ZAR",
			symbol: "R",
			original: "R",
			name: "South African Rand",
		},
		flag: "a/af/Flag_of_South_Africa",
		emoji: "🇿",
		emojiU: "U+1F1FF U+1F1E6",
		coordinates: [-30.5595, 22.9375],
	},
	ZM: {
		tld: ".zm",
		dial: "260",
		currency: {
			code: "ZMW",
			name: "Zambian Kwacha",
		},
		flag: "0/06/Flag_of_Zambia",
		emoji: "🇿",
		emojiU: "U+1F1FF U+1F1F2",
		coordinates: [-13.1339, 27.8493],
	},
	ZW: {
		tld: ".zw",
		dial: "263",
		currency: {
			code: "ZWL",
			symbol: "ZWL$",
			original: "ZWL$",
			name: "Zimbabwean Dollar",
		},
		flag: "6/6a/Flag_of_Zimbabwe",
		emoji: "🇿",
		emojiU: "U+1F1FF U+1F1FC",
		coordinates: [-19.0154, 29.1549],
	},
};
